import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=bc85176a&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"
import style0 from "../styles/Video.css?vue&type=style&index=0&id=bc85176a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc85176a",
  null
  
)

export default component.exports